import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import Switches from '../../../../../components/fields/Switches/Switches';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';
import DateTimePicker from '../../../../../components/fields/DatePicker/DateTimePicker';
import FileInput from '../../../../../components/fields/FileInput/FileInput';
import { PROCEDURE_TYPE } from '../../../../../configs';
import CarDTO from '../../../../../dto/CarDTO';

export default function ContractForm(props) {
  const {
    control,
    formMeta,
    procedure,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const dto = new CarDTO({ procedure });
  const attributes = dto.getAttributesByName();

  const [showContract, setShowContract] = useState(
    isEdit ? !!(
      currentApplication?.application_vehicle_new?.ownership_contract_number
        || currentApplication?.application_vehicle_new?.ownership_contract_effective_date
        || currentApplication?.application_vehicle_new?.ownership_contract_expiration_date
    ) || currentApplication?.application_vehicle_new?.ownership_contract_number === null
      || currentApplication?.application_vehicle_new?.ownership_contract_effective_date === null
      || currentApplication?.application_vehicle_new?.ownership_contract_expiration_date === null : false,
  );

  useEffect(() => {
    setValue('application_vehicle_new.ownership_contract_number', !showContract ? null : (isEdit ? getValues('application_vehicle_new.ownership_contract_number') || '' : ''));
    setValue('application_vehicle_new.ownership_contract_effective_date', !showContract ? null : (isEdit ? getValues('application_vehicle_new.ownership_contract_effective_date') || '' : ''));
    setValue('application_vehicle_new.ownership_contract_expiration_date', !showContract ? null : (isEdit ? getValues('application_vehicle_new.ownership_contract_expiration_date') || '' : ''));
    if (!showContract) setValue('media.ownership_contract_files', null);
  }, [showContract]);

  if (![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure)) {
    return null;
  }

  return (
    <>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowContract(!showContract),
              value: showContract,
            }}
            label="Изменился договор"
          />
        </Col>
      </Row>
      {showContract && (
        <>
          <Row className="row-cols-3">
            <FieldDTOWithCol
              control={control}
              type="text"
              component={TextInputWithLabel}
              dtoObject={attributes.ownership_contract_number}
              variant="material"
              namePrefix="application_vehicle_new."
              withLabel
              formMeta={formMeta}
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              variant="material"
              dtoObject={attributes.ownership_contract_effective_date}
              namePrefix="application_vehicle_new."
              withLabel
              formMeta={formMeta}
              labelPrefix="new."
            />
            <FieldDTOWithCol
              control={control}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              variant="material"
              dtoObject={attributes.ownership_contract_expiration_date}
              namePrefix="application_vehicle_new."
              withLabel
              formMeta={formMeta}
              labelPrefix="new."
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.ownership_contract_files}
              variant="material"
              namePrefix="media."
              textarea
              multiple
            />
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
